// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Origens_GetOrigemResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/origens/getOrigem/<id>
 *
 * Returns a single Origem (translated + franchise-name enriched) or 404
 * via sendError when the id is unknown.
 *
 * @see Origens_model::get()
 */
import type { Origens_OrigemRow } from './Origens_OrigemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Origens_GetOrigemResponseDados = Origens_OrigemRow;

export type Origens_GetOrigemResponse = ApiResponse<Origens_GetOrigemResponseDados>;

registerResponseContract('Origens_GetOrigemResponse', {
  origem_id:          { type: 'number',  required: true },
  origem_nome:        { type: 'string',  required: true },
  origem_franquia_id: { type: 'number',  required: true },
  franquia:           { type: 'string',  required: false },
})
